import { useCallback, useReducer } from "react";

/**
 * Used to trigger a re-render of a component.
 */
export function useRerender() {
  const rerender = useReducer(() => ({}), [])[1];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(rerender, []);
}
